export default __webpack_public_path__ + "static/media/fit-to-height.264eccdc.svg";